import React from "react";
import { observer } from "mobx-react";
import {
  Card,
  Paper,
  Table,
  Text,
  Box,
  Drawer,
  TypographyStylesProvider,
} from "@mantine/core";
import {
  IconBolt,
  IconBoltFilled,
  IconClock,
  IconCoinBitcoinFilled,
} from "@tabler/icons-react";
import { Cubby } from "../stores/Cubby";
import { getArticle } from "./docsIndex";
import ArticleTitle from "./articleTitle";

const DocsDrawer = observer(({ cubby }: { cubby: Cubby }) => {
  const close = () => {
    cubby.setCurrentlyFocusedArticleSlug(null);
  };
  const article = getArticle(cubby.currentlyFocusedArticleSlug);

  return (
    <Drawer
      size="lg"
      zIndex={1000}
      opened={cubby.currentlyFocusedArticleSlug !== null}
      onClose={close}
      title={
        cubby.currentlyFocusedArticleSlug ? (
          <ArticleTitle cubby={cubby} />
        ) : null
      }
    >
      {cubby.currentlyFocusedArticleSlug && article ? (
        <> {article.content}</>
      ) : null}
    </Drawer>
  );
});

export default DocsDrawer;
